import { getCore } from '@/redux/core/getters/getCore';
import { StoreState } from '@/redux/types';

export const getPrintTypes = (state: StoreState) => getCore(state).printTypes;
